export default "__VITE_ASSET__DrxDyab8__"